module.exports = __webpack_public_path__ + "assistant.92dec06c.svg";